export default {
      id: "deliveroo-usage",
      viewBox: "0 0 47.692 52.841",
      url: "../../assets/" + "sprite.svg#deliveroo-usage",
      toString: function () {
        return this.url;
      }
    }